import { render, staticRenderFns } from "./SalesPeople.vue?vue&type=template&id=bdea2730&scoped=true&"
import script from "./SalesPeople.vue?vue&type=script&lang=js&"
export * from "./SalesPeople.vue?vue&type=script&lang=js&"
import style0 from "./SalesPeople.vue?vue&type=style&index=0&id=bdea2730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdea2730",
  null
  
)

export default component.exports